export enum PAETEPRoleType
{
    Unverified_Users = 1,
    Registered_User = 2,
    Teacher = 22,
    Principal = 23,
    District_Admin = 24,
    NTPE = 103,
    NTPE_Supervisor = 114,
    Nontenured = 116,
    Paraeducator = 122,
    Support_Staff = 125,
    Support_Staff_Supervisor = 126,
    /* Additional NTPE Supervisor Roles */
    Sup_Pupil_Services = 200,
    Sup_Curr_Instruction = 201,
    Sup_Voc_Education = 202,
    Sup_Spec_Education = 203,
    NTPE_Other_Supervisor = 204,
    /* Secondary Roles */
    Emergency_Cert = 801,
    Substitute = 802,
    /* Non Roles */
    Peer_Target_User = 996,
    Peer_Supervisor = 997,
    Building_Lead = 998,
    Super_Admin = 999
}